import './hooks';
import './plugins/VeeValidate';
import './plugins/ElementUI';
import './plugins/Mq';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import {mq} from './utils';
import VueGtag from 'vue-gtag';

Vue.config.productionTip = false;

Vue.use(VueGtag, {
  config: {id: googleAnalyticsId()},
  appName: 'My senseFly',
  pageTrackerScreenviewEnabled: true,
}, router);

new Vue({
  router,
  store,
  render: (h) => h(App),
  mq,
}).$mount('#app');


function googleAnalyticsId() {
  switch (process.env.VUE_APP_ENV) {
    case 'production' :
      return 'UA-6001988-10';
    case 'test' :
      return 'UA-6001988-11';
    default:
      throw new Error(`Unsupported VUE_APP_ENV: ${process.env.VUE_APP_ENV}`);
  }
}



// WEBPACK FOOTER //
// ./src/main.ts